import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * UrlSerializer personalizado para normalizar la barra final de las URLs.
 * Angular hace match internamente sin barra final, y la URL publica se serializa
 * segun environment.trailingSlash.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
    override parse(url: string): UrlTree {
        const [rawPath, rawSuffix = ''] = url.split(/(?=[?#])/);
        const path =
            rawPath.length > 1 && rawPath.endsWith('/')
                ? rawPath.slice(0, -1)
                : rawPath;

        return super.parse(path + rawSuffix);
    }

    override serialize(tree: UrlTree): string {
        const serialized = super.serialize(tree);
        const [rawPath, rawSuffix = ''] = serialized.split(/(?=[?#])/);
        let path = rawPath;

        if (rawPath.length > 1) {
            path = environment.trailingSlash
                ? rawPath.endsWith('/')
                    ? rawPath
                    : rawPath + '/'
                : rawPath.endsWith('/')
                  ? rawPath.slice(0, -1)
                  : rawPath;
        }

        return path + rawSuffix;
    }
}
